/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { LinkFieldDisplay } from "./display";
import { LinkFieldEdit } from "./edit";

const LinkField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <LinkFieldDisplay />,
        editComponent: <LinkFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
LinkField.displayName = "LinkField";
export { LinkField };
